import debounce from 'lodash/debounce';
import { find, findMany, hasClass, addClass, removeClass, on } from '../helpers';

// Find all elements with the attribute '[data-block="alternating-image-text"]' and store them in 'dataBlocks'
const dataBlocks = findMany('[data-block="alternating-image-text"]');

// Define CSS class names as constants for readability and reuse
const marginClass = 'xl:mb-12';
const selfEndClass = 'xl:self-end';
const selfStartClass = 'xl:self-start';

// Function to change the position of blocks based on conditions
const changeBlockPosition = () => {
    // Loop through each 'dataBlock'
    dataBlocks.forEach(block => {
        // Loop through each child element of the 'dataBlock'
        Array.from(block.children).forEach(item => {
            // Find elements with the attribute '[data-alt-img-txt="text"]' and '[data-alt-img-txt="image"]' within the current 'block'
            const textBlock = find('[data-alt-img-txt="text"]', item);
            const imgBlock = find('[data-alt-img-txt="image"]', item);

            // Check if the height of 'textBlock' is greater than 488 pixels
            if (textBlock.clientHeight > 488) {
                // Check if 'textBlock' has the 'marginClass' and remove it if present
                hasClass(textBlock, marginClass) && removeClass(textBlock, marginClass);

                // Check if 'imgBlock' has the 'selfEndClass' and replace it with 'selfCenterClass' if present
                hasClass(imgBlock, selfEndClass) && (removeClass(imgBlock, selfEndClass), addClass(imgBlock, selfStartClass));
            }
        });
    });
};

// Function to handle viewport changes
const handleViewportChange = () => {
    // Check if the viewport width is greater than or equal to 1280 pixels
    if (window.innerWidth >= 1280) {
        // Call the 'changeBlockPosition' function to update block positions
        changeBlockPosition();
    }
};

// Attach a 'load' event listener to the window, which triggers 'handleViewportChange' on page load
on('load', handleViewportChange, window);

// Attach a 'resize' event listener to the window, which triggers 'handleViewportChange' with debouncing (300ms delay) on window resize
on('resize', debounce(handleViewportChange, 300), window);
